import { createClient } from "@supabase/supabase-js";

// Resolved from NEXT_PUBLIC_SUPABASE_URL / NEXT_PUBLIC_SUPABASE_ANON_KEY
// at build time. The anon key is designed to be public (it ships to
// browsers), so this file is safe to commit — values belong in env so
// dev/staging/prod can point at different projects without a code edit.
const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "Missing NEXT_PUBLIC_SUPABASE_URL or NEXT_PUBLIC_SUPABASE_ANON_KEY — copy frontend/.env.example to frontend/.env.local and fill them in."
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
